var _style, _g, _g2, _g3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadeInGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57 43",
    style: {
      enableBackground: "new 0 0 57 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1D1D1B;}\r\n\t.st1{fill:#E20613;}\r\n\t.st2{fill:#FFEC00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.9,10.6V4.7l-2.1,4.6H24l-2.1-4.6v5.9h-0.8V2.9h0.8l2.5,5.5l2.4-5.5h0.8v7.7H26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.4,10.6l-0.6-1.7h-3.4l-0.6,1.7h-0.9l2.8-7.7h0.7l2.8,7.7H34.4z M32.1,4.1l-1.5,4.1h2.9L32.1,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,9.9c-0.5,0.5-1.1,0.7-2,0.7h-2.6V2.9h2.6c0.8,0,1.5,0.2,2,0.7c0.8,0.8,0.8,2,0.8,3.1 C41.9,7.7,41.9,9.1,41.1,9.9z M40.5,4.2c-0.4-0.4-0.9-0.6-1.5-0.6h-1.7v6.2H39c0.6,0,1.1-0.2,1.5-0.6c0.5-0.6,0.5-1.7,0.5-2.6 C41.1,5.7,41.1,4.7,40.5,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.8,10.6V2.9h4.8v0.7h-4v2.7H48v0.7h-3.4v2.8h4v0.7H43.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.9,25.5v-7.7h0.8v7.7H39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.9,25.5l-4.1-6.2v6.2H43v-7.7h0.8l4.1,6.2v-6.2h0.8v7.7H47.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.8,39.6c-0.5,0.6-1.3,0.9-2.1,0.9c-0.8,0-1.5-0.3-2-0.8C0,38.9,0,38.2,0,36.5c0-1.6,0-2.4,0.7-3.1 c0.5-0.5,1.2-0.8,2-0.8c1.5,0,2.5,1,2.7,2.3H4.6c-0.2-1-0.9-1.6-1.9-1.6c-0.5,0-1,0.2-1.3,0.6c-0.5,0.5-0.5,1-0.5,2.6 c0,1.6,0.1,2.1,0.5,2.6c0.3,0.3,0.8,0.5,1.3,0.5c0.6,0,1.1-0.2,1.5-0.7c0.3-0.4,0.4-0.8,0.4-1.4v-0.6H2.7v-0.7h2.7v1.2 C5.4,38.5,5.2,39.1,4.8,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.3,40.4v-7.7h4.8v0.7h-4v2.7h3.4v0.7H8.2v2.8h4v0.7H7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,40.4L16.5,37h-1.9v3.4h-0.8v-7.7h3c1.3,0,2.3,0.8,2.3,2.1c0,1.1-0.7,1.9-1.7,2.1l1.8,3.5H18.3z  M16.7,33.4h-2.1v2.8h2.1c0.9,0,1.5-0.5,1.5-1.4C18.3,33.9,17.6,33.4,16.7,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.7,40.4v-5.9l-2.1,4.6h-0.7l-2.1-4.6v5.9h-0.8v-7.7h0.8l2.5,5.5l2.4-5.5h0.8v7.7H26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.3,40.4l-0.6-1.7h-3.4l-0.6,1.7h-0.9l2.8-7.7h0.7l2.8,7.7H34.3z M32,33.9l-1.5,4.1h2.9L32,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.3,40.4l-4.1-6.2v6.2h-0.8v-7.7h0.8l4.1,6.2v-6.2h0.8v7.7H41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4,37.2v3.2h-0.8v-3.2l-2.3-4.5h0.9l1.8,3.7l1.8-3.7h0.9L46.4,37.2z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    className: "st0",
    width: 2.7,
    height: 14.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 14.3,
    className: "st1",
    width: 2.7,
    height: 14.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 28.6,
    className: "st2",
    width: 2.7,
    height: 14.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadeInGermany);
export default __webpack_public_path__ + "static/media/Made-in-Germany.8537827f0177400979e4092fc140bbec.svg";
export { ForwardRef as ReactComponent };